module.exports = __webpack_public_path__ + "static/media/paySnackGift.7ae611e3.gif";